module.exports = __webpack_public_path__ + "media/images/club-award-812f7f2e01ab8e9bcc4e9b9f7894cadd.jpg";